import React, { FunctionComponent } from "react";

const LegalHammer: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/work-office-companies/legal/legal-hammer
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.75 -0.75 24 24">
      <g>
        <path
          d="m12.69375 8.04375 8.746875 8.240625a1.2281250000000001 1.2281250000000001 0 0 1 0 1.734375l-0.8718750000000001 0.8718750000000001a1.2281250000000001 1.2281250000000001 0 0 1 -1.734375 0l-8.240625 -8.746875"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M3.609375 8.00625a17.86875 17.86875 0 0 0 6.946875 -6.946875 1.2281250000000001 1.2281250000000001 0 0 1 1.734375 0l3.290625 3.290625a1.2375 1.2375 0 0 1 0 1.7437500000000001 16.959375 16.959375 0 0 0 -6.946875 6.9375 1.2281250000000001 1.2281250000000001 0 0 1 -1.734375 0l-3.290625 -3.290625a1.2281250000000001 1.2281250000000001 0 0 1 0 -1.734375Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M11.953125 19.453125h0a1.40625 1.40625 0 0 0 -1.40625 -1.40625h-7.03125a1.40625 1.40625 0 0 0 -1.40625 1.40625h0v2.34375h9.84375Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="m0.703125 21.796875 12.65625 0"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export default LegalHammer;
